import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { Link } from "react-router-dom"

const menuItems = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: "home",
  },
  // {
  //   title: "Add Blog",
  //   url: "/dashboard/blog/add",
  //   icon: "edit",
  // },
  // {
  //   title: "Shedule Blog",
  //   url: "/dashboard/blog/shedule",
  //   icon: "edit",
  // },
  // {
  //   title: "Draft Blog",
  //   url: "/dashboard/blog/draft",
  //   icon: "edit",
  // },
   {
    title: "Post Blog",
    url: "/dashboard/blog/post",
    icon: "edit",
  },
  {
    title: "Published Blogs",
    url: "/dashboard/blog/published",
    icon: "file-text",
  },
  {
    title: "Scheduled Blogs",
    url: "/dashboard/blog/sheduled",
    icon: "user",
  },
  {
    title: "Drafted Blogs",
    url: "/dashboard/blog/drafted",
    icon: "file-text",
  },
  
//   {
//     title: "Properties",
//     url: "/dashboard/properties",
//     icon: "building",
//   },
//   {
//     title: "Add Property",
//     url: "/dashboard/properties/add",
//     icon: "plus",
//   },
  // {
  //   title: "Inquiries",
  //   url: "/dashboard/inquiries",
  //   icon: "users",
  // },
  
  
]

const getIcon = (iconName) => {
  const icons = {
    home: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        />
      </svg>
    ),
    user: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>
    ),
    building: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-3 4h1m-1 4h1"
        />
      </svg>
    ),
    plus: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
    ),
    users: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
        />
      </svg>
    ),
    "file-text": (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
    edit: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        />
      </svg>
    ),
    close: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
  }
  return icons[iconName] || icons.home
}

export function AdminSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const location = useLocation()

  const handleMobileToggle = () => {
    setIsMobileOpen(!isMobileOpen)
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  useEffect(() => {
    const handleToggle = () => {
      if (isMobile) {
        handleMobileToggle()
      } else {
        setIsCollapsed(!isCollapsed)
      }
    }

    window.addEventListener("toggleSidebar", handleToggle)
    return () => window.removeEventListener("toggleSidebar", handleToggle)
  }, [isMobile, isCollapsed])

  if (isMobile) {
    return (
      <>
        <div
          className={`fixed inset-0 z-50 md:hidden transition-all duration-300 ${
            isMobileOpen ? "visible opacity-100" : "invisible opacity-0"
          }`}
        >
          <div
            className={`fixed inset-0 bg-black transition-opacity duration-300 ${
              isMobileOpen ? "opacity-50" : "opacity-0"
            }`}
            onClick={handleMobileToggle}
          />

          <div
            className={`fixed left-0 top-0 h-full w-80 bg-white shadow-xl transform transition-transform duration-300 ${
              isMobileOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                  <div className="text-white">{getIcon("building")}</div>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Admin Portal</h2>
                  <p className="text-sm text-gray-500">Dashboard</p>
                </div>
              </div>
              <button
                onClick={handleMobileToggle}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                {getIcon("close")}
              </button>
            </div>

            <div className="py-6">
              <div className="px-6 space-y-3">
                {menuItems.map((item) => {
                  const isActive = location.pathname === item.url
                  return (
                    <Link
                      key={item.title}
                      to={item.url}
                      onClick={handleMobileToggle}
                      className={`flex items-center px-4 py-3 rounded-lg text-base font-medium transition-all ${
                        isActive
                          ? "bg-gradient-to-r from-blue-50 to-purple-50 text-blue-700 border-l-4 border-blue-600"
                          : "text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <div
                        className={`mr-4 ${
                          isActive ? "text-blue-600" : "text-gray-400"
                        }`}
                      >
                        {getIcon(item.icon)}
                      </div>
                      <span>{item.title}</span>
                    </Link>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="hidden md:block">
        <div
          className={`fixed left-0 top-0 h-full bg-white border-r border-gray-200 transition-all duration-300 z-40 ${
            isCollapsed ? "w-20" : "w-64"
          }`}
        >
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <div className="text-white">{getIcon("building")}</div>
              </div>
              {!isCollapsed && (
                <div>
                  <h2 className="font-bold text-xl text-gray-900">Admin Portal</h2>
                  <p className="text-sm text-gray-500">Dashboard</p>
                </div>
              )}
            </div>
          </div>

          <div className="py-6">
            <div className="px-4 space-y-2">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.url
                return (
                  <Link
                    key={item.title}
                    to={item.url}
                    className={`flex items-center px-4 py-3 rounded-xl text-sm font-medium transition-all group ${
                      isActive
                        ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
                        : "text-gray-700 hover:bg-gray-50 hover:shadow-md"
                    }`}
                  >
                    <div
                      className={`flex-shrink-0 ${
                        isActive ? "text-white" : "text-gray-400 group-hover:text-gray-600"
                      }`}
                    >
                      {getIcon(item.icon)}
                    </div>
                    {!isCollapsed && (
                      <span className="ml-4 font-medium">{item.title}</span>
                    )}
                    {isCollapsed && (
                      <div className="absolute left-20 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-all pointer-events-none z-50">
                        {item.title}
                      </div>
                    )}
                  </Link>
                )
              })}
            </div>
          </div>

          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="absolute -right-4 top-24 w-8 h-8 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110"
          >
            <svg
              className={`w-4 h-4 text-gray-600 transition-transform duration-300 ${isCollapsed ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>

        <div className={`transition-all duration-300 ${isCollapsed ? "ml-20" : "ml-64"}`} />
      </div>
    </>
  )
}